import clsx from 'clsx'

const PileInput: React.FC<any> = props => {
  const { onChange, field } = props.cell.column

  if (props.row.original.pileQuantity === 0 || props.row.original.availableForShipment === 0) {
    return null
  }

  return (
    <>
      <input
        type='text'
        className={clsx('form-control form-control-sm', {
          'is-invalid': (props.value ?? 0) > props.row.original.availableForShipment,
        })}
        value={props.value ?? ''}
        onChange={(e: any) => onChange(props.row.original.id, field, e.target.value)}
      />
      {(props.value ?? 0) > props.row.original.availableForShipment && (
        <div className='fv-plugins-message-container'>
          <span role='alert' className='fv-help-block'>
            จำนวนที่ขนส่งต้องน้อยกว่าจำนวนที่สามารถขนส่งได้
          </span>
        </div>
      )}
    </>
  )
}

export default PileInput
